import { array, boolean, object, string } from "yup";

export const schema = (t) => {
  return object({
    promoCode: string()
      .required(t("validation:required-field"))
      .test("promoCode", "", (val) => (val ? val.length <= 10 : true))
      .trim(),
    providerId: string().required(t("validation:required-field")),
    isGeneral: boolean(),
    doctorIds: array().of(string()).notRequired(),
    promoCodeType: string().required(t("validation:required-field")),
    value: string()
      .required(t("validation:required-field"))
      .matches(/^-?\d*\.?\d{0,2}$/, {
        message: t("validation:invalid-amount"),
      }),
    dateRange: array()
      .required(t("validation:required-field"))
      .min(2, t("validation:required-field")),
    reusability: boolean(),
  });
};
